import React, { useContext, useRef, useState } from "react";
import "./cartProductCard.css";
import { Col, Row } from "react-bootstrap";
import Button from "../button/Button";
import { CartContext } from "../../contexts/CartContext";
import { AuthContext } from "../../contexts/AuthContext";
import { ENDPOINT, getJWT, getOutletSessionId } from "../../helpers/Helper";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

function CartProductCard({ product }) {
  const jwt = getJWT();

  const toastId = useRef(null);

  const { triggerReload } = useContext(CartContext);
  const { authState } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [loadingQuantity, setLoadingQuantity] = useState(false);

  const productPrice = product && product.price;

  const handleRemoveProduct = (e) => {
    e.preventDefault();

    setLoading(true);

    if (authState !== undefined) {
      axios
        .put(
          `${ENDPOINT}/cart`,
          {
            productId: product._id,
          },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        .then((res) => {
          if(! toast.isActive(toastId.current)) {
            toastId.current = toast(
              `${product.name} has been removed from your cart successfully`,
              {
                type: "success",
                position: "top-right",
                autoClose: "1000",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
              }
            );
          }
          triggerReload();
          setLoading(false);
        })
        .catch((err) => {
          if(! toast.isActive(toastId.current)) {
            toastId.current = toast(`Oops! ${err.response.data.error}`, {
              type: "error",
              position: "top-right",
              autoClose: "1000",
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          
          setLoading(false);
        });
    } else {
      axios
        .put(
          `${ENDPOINT}/cart`,
          {
            productId: product._id,
          },
          { headers: { sessionId: `${getOutletSessionId()}` } }
        )
        .then((res) => {
          if(! toast.isActive(toastId.current)) {
            toastId.current = toast(
              `${product.name} has been removed from your cart successfully`,
              {
                type: "success",
                position: "top-right",
                autoClose: "1000",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
              }
            );
          }
          
          triggerReload();
          setLoading(false);
        })
        .catch((err) => {
          if(! toast.isActive(toastId.current)) {
            toastId.current = toast(`Ooop! Something wrong happened. ${err}`, {
              type: "error",
              position: "top-right",
              autoClose: "1000",
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          
          setLoading(false);
        });
    }
  };

  const handleReduceQuantity = (e) => {
    e.preventDefault();

    const jwt = getJWT();

    setLoadingQuantity(true);

    if (authState !== undefined) {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: product.productId,
            quantity: product.quantity - 1,
          },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        .then((res) => {
          triggerReload();
          setLoadingQuantity(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setLoadingQuantity(false);
        });
    } else {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: product.productId,
            quantity: product.quantity - 1,
          },
          { headers: { sessionId: `${getOutletSessionId()}` } }
        )
        .then((res) => {
          triggerReload();
          setLoadingQuantity(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setLoadingQuantity(false);
        });
    }
  };

  const handleIncreaseQuantity = (e) => {
    e.preventDefault();

    const jwt = getJWT();

    setLoadingQuantity(true);

    if (authState !== undefined) {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: product.productId,
            quantity: product.quantity + 1,
          },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        .then((res) => {
          triggerReload();
          setLoadingQuantity(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setLoadingQuantity(false);
        });
    } else {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: product.productId,
            quantity: product.quantity + 1,
          },
          { headers: { sessionId: `${getOutletSessionId()}` } }
        )
        .then((res) => {
          triggerReload();
          setLoadingQuantity(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setLoadingQuantity(false);
        });
    }
  };

  return (
    <Row className="cartProduct">
      <Col md={3} sm={2}>
        <img
          src={product && product.imageUrl}
          className="cartProduct__img"
          alt=""
        />
      </Col>
      <Col md={9} sm={9}>
        <div className="removeProduct__btn" onClick={handleRemoveProduct}>
          {loading ? (
            <i class="bx bx-loader"></i>
          ) : (
            <i className="bx bx-x removeProduct__btn"></i>
          )}
        </div>

        <div className="cartProduct__Details">
          <h4>{product.productName}</h4>
        </div>

        <div className="cartProduct__Details">
          <h5>Ksh {+productPrice * +product.quantity}</h5>

          <React.Fragment>
            <Button
              content="-"
              contentColor="black"
              contentSize="large"
              onClickHandler={(e) => handleReduceQuantity(e)}
              borderRadius="left"
            />

            <p>
              {loadingQuantity ? (
                <i class="bx bx-loader"></i>
              ) : (
                <React.Fragment>
                  <i className="bx bx-cart cartProduct__Quantity"></i>{" "}
                  {product.quantity}
                </React.Fragment>
              )}
            </p>

            <Button
              content="+"
              contentColor="black"
              contentSize="large"
              onClickHandler={(e) => handleIncreaseQuantity(e)}
              borderRadius="right"
            />
          </React.Fragment>
        </div>

        <ToastContainer />
      </Col>
    </Row>
  );
}

export default CartProductCard;
